import { REQ } from "constants/api/requests"
import { IResponse } from "constants/interfaces"

import useApi, { parseError } from "util/api"

export const PaymentServiceAdmin = {
  async getCurRates(currency: string): Promise<{ rates: Record<string, number> } | null> {
    try {
      const { data } = await useApi.get<IResponse<{ rates: Record<string, number> }>>(REQ.ADMIN_DASHBOARD.PAYMENTS.CUR_EXCHANGE_RATES, {
        params: { currency }
      })

      if (data?.success) {
        return data.response
      }
    } catch (error) {
      parseError(error, "Failed to fetch currency rates")
    }

    return null
  }
}
